export enum CheckoutStatus {
  CANCELED = 'Canceled',
  CANCELLED = 'Cancelled',
  EXPIRED = 'Expired',
  FINALIZED = 'Finalized',
  PAID = 'Paid',
  PENDING = 'Pending_payment',
  ISSUED = 'Issued',
}

export const fingerprintHashSeed = 31;

export enum PaymentMethod {
  CARD = 'Card',
  CASH = 'Cash',
  BANK_TRANSFER = 'BankTransfer',
  Bnpl = 'Bnpl',
}

export const binPhysicalProducts = [
  '455529',
  '554629',
  '542010',
  '542977',
  '547077',
  '547086',
  '455545',
  '493160',
  '493161',
  '547155',
  '455507',
  '455503',
  '544551',
  '455500',
  '455506',
  '455515',
  '455527',
  '410177',
  '455511',
  '455533',
  '415231',
  '455510',
  '455514',
  '547492',
  '455502',
  '455501',
  '455525',
  '455526',
  '444086',
  '444085',
  '418075',
  '415327',
  '441314',
  '455513',
  '544053',
  '547095',
  '547156',
  '455540',
  '493162',
  '455505',
  '409851',
  '418077',
  '455518',
  '522498',
  '418093',
  '418094',
  '444087',
  '418090',
  '441312',
  '418073',
  '418076',
  '477291',
  '408340',
  '494398',
  '477211',
  '535875',
  '410180',
  '446117',
  '455519',
  '455504',
  '455508',
  '477210',
  '446115',
  '477213',
  '410181',
  '477214',
  '446116',
  '441311',
  '477292',
  '542015',
  '517439',
  '446118',
  '411808',
  '455509',
  '418078',
  '418080',
  '543792',
];
